import { QUOTATION_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useQuotationList } from './hook';
import { QuotationListProps } from './props';

export const QuotationList = ({ filters }: QuotationListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useQuotationList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${QUOTATION_DETAIL}/${item.row.id}`, '_blank')
            }
        />
    );
};
